﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import { PubChemCompound } from '../../models/ExternalData/pubchem-compound';
import { PubChemProp } from '../../models/ExternalData/pubchem-prop';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType } from '../../models/enums';
import { CrudFunctions } from '../../utilities/crud-functions';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    Selection,
    Button as ColumnButton,
    Toolbar,
    Item as ToolbarItem,
    Paging,
    LoadPanel
} from 'devextreme-react/data-grid';

import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';

let key = 0;

export default function PubChemDataPortal() {
    const [casNumber, setCasNumber] =
        useState<string>();

    const [pubChemCompounds, setPubChemCompounds] =
        useState<PubChemCompound[]>();

    const [selectedPubChemCompound, setSelectedPubChemCompound] =
        useState<PubChemCompound>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">PubChem Data</div>

                <div className="title-bar-spacer" />
            </div>

            <div className="pw-comp-row">
                <div className="pw-comp-15">
                    <div className="pw-form-unit-label">Search by CAS#:</div>
                    <TextBox inputAttr={{ id: "SearchByCasNumberTextBox" }}
                        className="textbox"
                        width={'20em'} data-testid="products-search-textbox"
                        onValueChanged={casNumberChanged}
                        placeholder="search by cas number" value={casNumber} />
                </div>

                <div className="pw-margin-top-08">
                    <Button elementAttr={{ id: "searchByCasNumberButton" }}
                        text="Search" type="default"
                        className="pw-margin-left-05"
                        onClick={searchPubChemButtonClicked} />

                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="16rem"
                    dataSource={pubChemCompounds ? pubChemCompounds : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    onSelectionChanged={onPubChemSelectionChanged}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />
                    <Selection mode='single' />

                    <Column dataField='cid' caption="CID#" dataType='string' width='10rem' />
                                     
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">PubChem Compounds</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>
                </DataGrid>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="16rem"
                    dataSource={selectedPubChemCompound && selectedPubChemCompound.properties ?
                        selectedPubChemCompound.properties : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>
                                       
                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column dataField='label' dataType='string' width='10rem' />
                    <Column dataField='name' dataType='string' width='10rem' />
                    <Column dataField='value' dataType='string' />
                    <Column dataField='source' dataType='string' width='8rem' />
                    <Column dataField='software' dataType='string' width='8rem' />
                    <Column dataField='version' dataType='string' width='8rem' />
                    <Column dataField='release' dataType='string' width='8rem' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Properties</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>
                </DataGrid>
            </div>

            <DmaFooter />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onPubChemSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedPubChemCompound(e.selectedRowsData[0]);
    }

    function casNumberChanged(e: any) {
        setCasNumber(e.value);
    }

    function searchPubChemButtonClicked() {
        if (casNumber)
            getPubChemData();

    }

    async function getPubChemData() {
        await CrudFunctions.getData(`externaldata/pubchemdata/${casNumber}`)
            .then((data) => {
                setPubChemCompounds(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving PubChem data");
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

